var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquadIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1248 10.1223C14.5236 10.1223 15.6576 8.98832 15.6576 7.58947C15.6576 6.19063 14.5236 5.05664 13.1248 5.05664C11.7259 5.05664 10.5919 6.19063 10.5919 7.58947C10.5919 8.98832 11.7259 10.1223 13.1248 10.1223Z",
    stroke: "#ACACAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1664 12.3744C14.4413 10.8075 11.8081 10.8075 10.0831 12.3744",
    stroke: "#ACACAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6576 7.67362C15.2002 7.80543 14.7265 7.87212 14.2505 7.87174C12.9802 7.87363 11.7561 7.39633 10.8223 6.53516",
    stroke: "#ACACAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.378 19.1282C19.7769 19.1282 20.9109 17.9942 20.9109 16.5953C20.9109 15.1965 19.7769 14.0625 18.378 14.0625C16.9792 14.0625 15.8452 15.1965 15.8452 16.5953C15.8452 17.9942 16.9792 19.1282 18.378 19.1282Z",
    stroke: "#ACACAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9427 21.9426C21.0857 20.8448 19.7707 20.2031 18.378 20.2031C16.9853 20.2031 15.6703 20.8448 14.8133 21.9426",
    stroke: "#ACACAC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9108 16.6775C19.2108 17.1671 17.3786 16.7357 16.0756 15.5391",
    stroke: "#ACACAC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62194 19.1282C10.0208 19.1282 11.1548 17.9942 11.1548 16.5953C11.1548 15.1965 10.0208 14.0625 8.62194 14.0625C7.2231 14.0625 6.08911 15.1965 6.08911 16.5953C6.08911 17.9942 7.2231 19.1282 8.62194 19.1282Z",
    stroke: "#ACACAC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1859 21.9426C11.3289 20.8448 10.0139 20.2031 8.62118 20.2031C7.22848 20.2031 5.91346 20.8448 5.05646 21.9426",
    stroke: "#ACACAC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1548 16.6775C9.45478 17.1671 7.62253 16.7357 6.31952 15.5391",
    stroke: "#ACACAC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 25.5C6.87258 25.5 1.5 20.1274 1.5 13.5H-1.5C-1.5 21.7843 5.21573 28.5 13.5 28.5V25.5ZM25.5 13.5C25.5 20.1274 20.1274 25.5 13.5 25.5V28.5C21.7843 28.5 28.5 21.7843 28.5 13.5H25.5ZM13.5 1.5C20.1274 1.5 25.5 6.87258 25.5 13.5H28.5C28.5 5.21573 21.7843 -1.5 13.5 -1.5V1.5ZM13.5 -1.5C5.21573 -1.5 -1.5 5.21573 -1.5 13.5H1.5C1.5 6.87258 6.87258 1.5 13.5 1.5V-1.5Z",
    fill: "#ACACAC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquadIcon);
export default __webpack_public_path__ + "static/media/squad-icon.68fc4c917e2ac3e7338992196f1f60b9.svg";
export { ForwardRef as ReactComponent };